import moment from 'moment';
export default {
	getSearchDates_({ searchParams: { strDt, endDt } }) {
		return [moment(strDt).format('YYYY-MM'), moment(endDt).format('YYYY-MM')];
	},
	getEqipKndCd_({ eqipKndCdList }) {
		return eqipKndCdList.filter(el => el.value !== 'S');
	},
	stackedLabel_({ graphList }) {
		const labelArray = [];
		for (const item of graphList) {
			labelArray.push(item.calYyyy + '/' + item.calMm);
		}
		return labelArray;
	},
	stackedDataSet_({ graphList }, getters, rootState, rootGetters) {
		const barPlan = [],
			barResult = [];
		const resultColor = '#FFA0FF',
			planColor = '#99CCFF';
		for (const val of graphList) {
			barPlan.push(val.planCnt);
			barResult.push(val.resultCnt);
		}
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001661'), //계획,
				data: barPlan,
				borderColor: planColor,
				backgroundColor: planColor,
				borderWidth: 1,
				order: 1
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001450'), //실적,
				data: barResult,
				borderColor: resultColor,
				backgroundColor: resultColor,
				borderWidth: 1,
				order: 2
			}
		];
	},
	sumLabel_({ resultList }, getters, rootState, rootGetters) {
		return [
			// ' '
			rootGetters['commonStore/getMessage_']('QWCC001669'), //전체수량
			rootGetters['commonStore/getMessage_']('QWCC001670'), //정상수량
			rootGetters['commonStore/getMessage_']('QWCC001671'), //적합
			rootGetters['commonStore/getMessage_']('QWCC001672'), //부적합
			rootGetters['commonStore/getMessage_']('QWCC001673'), //운휴수량
			rootGetters['commonStore/getMessage_']('QWCC001674'), //고장수량
			rootGetters['commonStore/getMessage_']('QWCC001675') //기타수량
		];
	},
	sumDataSet_({ resultList }, getters, rootState, rootGetters) {
		const barPlan = [
			resultList.totCnt,
			resultList.normCnt,
			resultList.okCnt,
			resultList.ngCnt,
			resultList.stpgCnt,
			resultList.bkdwCnt,
			resultList.etcCnt
		];
		const colors = ['#13C7A3', '#89FB89', '#82F0F0', '#99CCFF', '#A0DFE1', '#6FCC98', '#AAEBAA'];
		return [
			{
				label: getters.sumLabel_,
				data: barPlan,
				borderColor: colors,
				backgroundColor: colors,
				borderWidth: 1
			}
		];
	}
};
